import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { CoreMenuItem } from "src/app/menu/core-menu";

@Component({
  selector: "app-side-menu-accordion",
  templateUrl: "./menu-accordion.component.html",
  styleUrl: "./menu-accordion.component.scss",
})
export class SideMenuAccordionComponent {
  @Input() menu: CoreMenuItem;
  @ViewChild("menuTitle", { static: true }) menuTitle!: ElementRef;

  setDataLink(url: string) {
    this.menuTitle.nativeElement.setAttribute("data-link", url);
  }
}
